
import { defineComponent, ref, onBeforeUnmount, Ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { ImagePreview } from 'vant'
import uploadFilesSetup from '@/compositions/uploadFiles'
// import { ImageInfo, UploadFile } from '@/types/public'

export default defineComponent({
  name: 'Fault-Detection',
  components: {
    AppHeader,
  },
  setup() {
    const images: string[] = [
      'https://img.yzcdn.cn/vant/apple-1.jpg',
      'https://img.yzcdn.cn/vant/apple-2.jpg',
    ]
    const { getFiles } = uploadFilesSetup()
    let _ts: number = Date.now()
    const describe: Ref<string> = ref(
      '定损物料明细或数量发生变化，提交后维修定损明细清单需先由客户确认后再生成出库单。'
    )
    onBeforeUnmount(() => {
      _ts = 0
    })
    return {
      images,
      describe,
      getFiles,
      _ts,
    }
  },
  methods: {
    getBigImages(i: number): void {
      ImagePreview({
        images: this.images,
        startPosition: i,
      })
    },
    // this.getFiles(files, fileStrArr).then((res) => {
    //         if (res?.fileObjArr?.length) {
    //           const { fileObjArr, files } = res
    //           this.onSetImages(fileObjArr, files)
    //         }
    //       })
  },
})
